import React, { useEffect } from 'react';
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { Link } from "react-router-dom";
import InHomeFaq from './InHomeFaq'

import GenericCarousel from "../common/GenericCarousel"
import GenericCollapseWithChildren from "../common/GenericCollapseWithChildren";

import SchedulingQuestions from './SchedulingQuestions'

const InHomeLanding = ({ costLabel, history }) => {

    useEffect(() => {
        logUI(`MBHWeb.UI.InHomeLanding.Displayed`, new Date(), Tools.getURLPath())
    }, []);   

    const slides = () => {
        let slidesArray = []
        slidesArray.push(<div className="image-box" key="1" >
            <h3 className="step-count">STEP 1</h3>
            <h4 className="step-title">Book</h4>
            <p className="step-msg">Book a vaccine appointment</p>
            <img src="/images/book.svg" alt="Book" />
        </div >)
        slidesArray.push(<div className="image-box" key="2">
            <h3 className="step-count">STEP 2</h3>
            <h4 className="step-title">Track</h4>
            <p className="step-msg">Track your medical professional as they travel to your home</p>
            <img src="/images/track.svg" alt="track" />
        </div>)
        slidesArray.push(<div className="image-box" key="3">
            <h3 className="step-count">STEP 3</h3>
            <h4 className="step-title">Receive</h4>
            <p className="step-msg">Receive your vaccine in the comfort of your home</p>
            <img src="/images/receive.svg" alt="receive" />
        </div>)
        return slidesArray;
    }

    return (
        <div className="container-fluid body-content inhome inhome-landing-container">
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <div className="row">
                        <div className="col-12">
                            <h1 className="page-heading">You can now book in-home vaccines.</h1>
                            <p className="subheading-info">Once the vaccine appointment is set, a trusted medical provider will visit your home, administer the vaccine, and document the encounter for your medical records.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row copay-banner-wrapper">
                <div className="col-12 maxWidth-content">
                    <div className="row">
                        <div className="col-12 copay-banner-content">
                            <span className="banner-sub-content">
                                <h3>Cost:</h3>
                                <span className="copay-heading-text">{costLabel}</span>
                            </span>

                            <button className="btn btn-primary cta"
                                onClick={() => {
                                    logUI(`MBHWeb.UI.InHomeLanding.BookVisit.Clicked`, new Date(), Tools.getURLPath());
                                    let route = `/inhomeschedule/s1`;
                                    history.push(route);
                                }}
                            >BOOK IN-HOME VISIT</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <div className="row">
                        <div className="col-12 inhome-image-container">
                            {slides()}
                        </div>
                        <div className="col-12 inhome-image-carousel">
                            <GenericCarousel slides={slides()} showArrows={false} infinite={false} />
                        </div>
                    </div>
                </div>
            </div>

            <InHomeFaq />
           
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <div className="row">
                        <div className="col-12">
                            <SchedulingQuestions />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        costLabel: state.memberships.inHomeVaccineCostLabel
    }
}


export default connect(mapStateToProps)(InHomeLanding);